<template>
  <nuxt-link
    v-if="!isExternal"
    :data-tealium-rel="slugify(webtrack, true)"
    :to="url"
    class="btn"
  >
    <slot />
  </nuxt-link>
  <a
    v-else
    class="btn"
    :href="url"
    :data-tealium-rel="slugify(webtrack, true)"
    target="_blank"
  >
    <slot />
    <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span>
    <SvgIcon
      :image="externalIcon"
      aria-hidden="true"
    />
  </a>
</template>

<script>
import { slugify } from '@i22-td-smarthome/component-library';
import externalIcon from '@/assets/images/external-link.svg';

export default {
  name: 'StageLink',
  props: {
    isExternal: { type: Boolean },
    url: { type: String, required: true },
    webtrack: { type: String, default: '' },
  },
  methods: {
    slugify,
  },
  data() {
    return {
      externalIcon,
    };
  },
};
</script>
